import React, { useEffect, useState, useRef, VFC, ChangeEvent, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import './editFunel.scss';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import moment from 'moment';
import { useAuth } from '@/lib/auth';
import Utils from '@/utils/util';
import { User } from '@/types';
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { PageHeader } from '@/components/PageHeaders/PageHeader';
import { Funnel, Group } from '../types/indes';
import InitialsAvatar from 'react-initials-avatar';

import { ReactComponent as Coverageicon } from '@/assets/steam/coverage-detail.svg';
import { ReactComponent as UploadAudioIcon } from '@/assets/steam/upload-audio-icon.svg';
import { ReactComponent as RecordingIcon } from '@/assets/steam/recording.svg';
import { ReactComponent as RedRecordingIcon } from '@/assets/steam/red-recording.svg';
import RedDataRecordingIcon from '@/assets/steam/mic.png';

import { default as ReactSelect, components } from 'react-select';
import { ReactComponent as BookFunnelIcon } from '@/assets/steam/book-funnel.svg';
import { ReactComponent as ProductFunnelicon } from '@/assets/steam/product-funnel.svg';
import { ReactComponent as FunnelIcon } from '@/assets/steam/funnel-icon.svg';
import { ReactComponent as Locationicon } from '@/assets/steam/grey-location.svg';
import Dropdown from 'react-bootstrap/Dropdown';
import { ReactComponent as Calendericon } from '@/assets/steam/calender-frame.svg';
import { ReactComponent as Deleteicon } from '@/assets/steam/delete-red.svg';
import { ReactComponent as Statusicon } from '@/assets/steam/status-funnel.svg';
import { useGetFunnelStagess } from '../api/getStages';
import DatePicker, { DayRange } from 'react-modern-calendar-datepicker';
import { ReactComponent as ProductIcon } from '@/assets/steam/product.svg';

import { useGetProductList } from '@/features/product/api/getProduct';
import { Product } from '@/features/product/types/indes';
import { City } from '@/features/users/types/indes';
import { State } from 'zustand';

import { ReactComponent as Callicon } from '@/assets/steam/call.svg';
import { ReactComponent as Download } from '@/assets/steam/download-grey.svg';
import { ReactComponent as AudioIcon } from '@/assets/steam/audio.svg';
import { ReactComponent as LastCoverageIcon } from '@/assets/steam/last-coverage.svg';
import { Contact } from '@/features/contact/types/indes';
import { useUpdateFunnel } from '../api/updateFunnel';
import { useGetPhoneDetails } from '../api/getInstitute';
import DeleteConfirmation from '@/components/DeleteConfirmation/DeleteConfirmation';
import { useUploadAudio } from '../api/uploadAudio';
import { showNotification } from '@/utils/notificationUtils';
import AudioPlayer from './audioPlayer';
import { Loader } from '@/components/Loader/Loader';
import { DESIGNATION_TYPES } from '@/utils/constants';
import { TableData } from '@/components/Table/TableData';
import { useGetUsersList } from '@/features/users/api/getProducts';


const EditFunnel: VFC<{
    selectedFunnel?: Funnel;
    onEditClick: () => void;
    onUpdateComplete: (id: any) => void;
    productList: any;
}> = ({ selectedFunnel, onEditClick, onUpdateComplete, productList }) => {
    const { user } = useAuth();
    const selectRef = useRef<HTMLDivElement | null>(null);
    const selectRef1 = useRef<HTMLDivElement | null>(null);

    const useGetUsersMutation = useGetUsersList();
    const uploadPicture = useUploadAudio();
    const [uploadedAudio, setUploadedAudio] = useState<string>();
    const fileInputRef = useRef(null);
    const [selectedContactType, setSelectedContactType] = useState(0);
    const [dropdownOpen1, setDropdownOpen1] = useState(false);


    const useGetFunnelStagessMutation = useGetFunnelStagess();
    const [funnelStages, setFuneelStages] = useState<[]>([]);
    const [selectedDate, setSelectedDate] = useState<any>();
    const [lastCoverageDate, setLastCoverageDate] = useState<any>();
    const [setSelectedFunnelStage, setSelectedFunnelState] = useState<any>();
   
    const [selectedFunnelDetails, setselectedFunnelDetails] = useState<Funnel>()
    const [city, setCity] = useState<City[]>([])
    const [comments, setComments] = useState<any>('');
    const [delaSize, setDealSize] = useState<any>('');
    const [productDetails, setProductDetails] = useState<Group[]>([]);
    const [contactsList, setContactList] = useState<Contact[]>([]);
    const useUpdateFunnelMutation = useUpdateFunnel();
    const useGetPhoneDetailsMutation = useGetPhoneDetails();
    const [showAddContactModal, setShowAddContactModal] = useState<boolean>(false);
    const [contactRes, setShowAddContactDetails] = useState<any>('');
    const [selectedAssignedTo, setSelectedAssignedTo] = useState<any>({ name: '', userId: null })
    const [isRecording, setIsRecording] = useState<boolean>(false);
    const [recorderaudioUrl, setAudioUrl] = useState<string | null>(null);
    const [mediaRecorderAudio, setMediaRecorder] = useState<MediaRecorder | null>(null);
    const chunks = useRef<Blob[]>([]);
    const [confirmationModal, showConfirmationDialog] = useState<any>('');
    


    const [dropdownOpenStates1, setDropdownOpenStates1] = useState(Array(productDetails.length).fill(false));
    const selectRefs1 = useRef([]);
    selectRefs1.current = productDetails.map((_, index) => selectRefs1.current[index] || React.createRef());
    const [usersList, setUsersList] = useState<User[]>([]);
    const [dropdownOpenStates, setDropdownOpenStates] = useState(Array(productDetails.length).fill(false));
    const selectRefs = useRef([]);
    selectRefs.current = productDetails.map((_, index) => selectRefs.current[index] || React.createRef());


    useEffect(() => {
        getUsersList(1)
        if (selectedFunnel) {
            setDealSize(selectedFunnel?.dealSize)
           // setComments(selectedFunnel?.comments)
            getFunnelStages(selectedFunnel?.type)
            setSelectedAssignedTo({userId:selectedFunnel?.assignedUser?.id, name:selectedFunnel?.assignedUser?.name})
            if (
                selectedFunnel?.institute?.contacts && selectedFunnel?.institute?.contacts.length > 0
            ) {
                setContactList(selectedFunnel?.institute?.contacts)
            }
            setSelectedFunnelState(selectedFunnel?.stage?.name)
            if (selectedFunnel?.productGroups && selectedFunnel?.productGroups.length > 0) {
                setProductDetails(selectedFunnel?.productGroups)
            }
            if (selectedFunnel?.followUpDate) {
                // const parsedDate = moment(selectedFunnel.followUpDate);
                // setSelectedDate({
                //     year: parsedDate.year(),
                //     month: parsedDate.month() + 1,
                //     day: parsedDate.date(),
                // });
                // const parsedDate1 = moment(selectedFunnel.coverageDate);
                // setLastCoverageDate({
                //     year: parsedDate1.year(),
                //     month: parsedDate1.month() + 1,
                //     day: parsedDate1.date(),
                // })
            }
            setselectedFunnelDetails(selectedFunnel);
        }
    }, [selectedFunnel])


    const getFunnelStages = async (id: any) => {
        const res = await useGetFunnelStagessMutation.mutateAsync({
            id: Number(id)
        });

        if (res) {
            setFuneelStages(res.list)
        }
    }

   

    const FUNNEL_TYPES = {
        BOOK_FUNNEL: '2',
        PRODUCT_FUNNEL: '1',
    };


    // const formatDateRange = () => {
    //     return selectedDate
    //         ? moment({
    //             year: selectedDate?.year,
    //             month: selectedDate?.month ? selectedDate?.month - 1 : 0,
    //             day: selectedDate?.day,
    //         }).format('DD MMM YYYY')
    //         : 'Select Date';
    // };

    // const formatDateRange1 = () => {
    //     return lastCoverageDate
    //         ? moment({
    //             year: lastCoverageDate?.year,
    //             month: lastCoverageDate?.month ? lastCoverageDate?.month - 1 : 0,
    //             day: lastCoverageDate?.day,
    //         }).format('DD MMM YYYY')
    //         : 'Select Date';
    // };

    const addNewProduct = () => {
        setProductDetails([
            ...productDetails,
            {
                productId: '',
                name: '',
                quantity: '',
                subject: '',
                class: '',
                price: '',
            }
        ]);
    }

    const addNewcontact = () => {
        setContactList([
            ...contactsList,
            {
                name: '',
                email: '',
                phone: '',
                isKeyPerson: false,
                isTelephonic: selectedContactType === 2 ? true : false,
                designation: ''
            }
        ]);
    }

    const getFunnelStafe = () => {
    
        if (selectedFunnelDetails && selectedFunnelDetails.stageId && ['6', '13', '14'].includes(selectedFunnelDetails?.stageId)) {
            return true;
        } else {
            return false;
        }
    }
    

    const updateFunnelDetails = async () => {
        const allValid = contactsList && contactsList.length > 0 && contactsList.every((contact: any) => contact.phone.length > 5);
            const allValidDesignation = contactsList && contactsList.length > 0 && contactsList.every((contact: any) => contact.designation);
            const allValidName = contactsList && contactsList.length > 0 && contactsList.every((contact: any) => contact.name);
            if (!allValid && contactsList && contactsList.length > 0) {
                showNotification({
                    type: 'error',
                    title: 'Please enter valid phone no.',
                });
            }else if(!allValidDesignation && contactsList && contactsList.length > 0) {
                showNotification({
                    type: 'error',
                    title: 'Please select designation.',
                });
            }else if (!allValidName && contactsList && contactsList.length > 0) {
                showNotification({
                    type: 'error',
                    title: 'Please enter valid contact name.',
                });
            } else if(!lastCoverageDate || lastCoverageDate === 'Select Date'){
                showNotification({
                    type: 'error',
                    title: 'Please select Date of Visit/Call.',
                });
            }else if(!getFunnelStafe() && (!selectedDate || selectedDate === 'Select Date')){
                showNotification({
                    type: 'error',
                    title: 'Please select Next Follow Up Date.',
                });
            }
        else if (Number(selectedFunnel?.type)=== 2 && productDetails && productDetails.length > 0) {

            const allValid = productDetails && productDetails.length > 0 && productDetails.every((contact: any) => contact.productId);
            if (!allValid ) {
                showNotification({
                    type: 'error',
                    title: 'Please enter product details.',
                });
            }else{
                addFunnel();
            }
        }
        else {
           
            addFunnel();
        

        }
        //console.log("data", data)
    }

    const addFunnel = async() =>{
        const contactss =  contactsList && contactsList.length>0 && contactsList.map((contact) => {
            if (!contact.id) {
              return {
                ...contact,
                phone: contact?.phone?.startsWith('+') ? contact.phone : `+${contact.phone}`, 
              };
            }
            return contact; 
          });
        const res = await useUpdateFunnelMutation.mutateAsync({
            id: selectedFunnel?.id ? selectedFunnel?.id : null,
            type: selectedFunnel?.type,
            instituteDetails: {
                id: selectedFunnel?.institute?.id,
                name: selectedFunnel?.institute?.name,
                address: selectedFunnel?.institute?.address
            },
            stageId: selectedFunnelDetails?.stageId,
            followUpDate: getFunnelStafe() ? null :  Utils.convertDateToISOFormat(formatDateRange()),
            dealSize: delaSize,
            contactDetails: contactss,
            coverageType: selectedContactType ? 'Telephonic' : 'inPerson',
            coverageDetails: comments,
            lastCoverageDate: Utils.convertDateToISOFormat(formatDateRange1()),
            audioFileUrl: uploadedAudio ? uploadedAudio : '',
            productDetails: Number(selectedFunnel?.type)=== 2 ? productDetails : null,
            assignedTo: selectedAssignedTo?.userId ? selectedAssignedTo?.userId :  selectedFunnel?.assignedUser
        });

        if (res && selectedFunnel) {
            onUpdateComplete(selectedFunnel.id)
        }
    }
    const onConfirm = () => {
        if (contactRes) {
            const updatedContatcDetails = [...contactsList];
            updatedContatcDetails[contactRes.index].phone = contactRes.phone;
            updatedContatcDetails[contactRes.index].name = contactRes.name;
            updatedContatcDetails[contactRes.index].email = contactRes.email;
            updatedContatcDetails[contactRes.index].id = contactRes.id;
            updatedContatcDetails[contactRes.index].designation = contactRes.designation;

            updateFunnelDetails
            setContactList(updatedContatcDetails);
            setShowAddContactDetails('')
        }
        setShowAddContactModal(false)
    }

    const onClose = () => {
        const updatedContatcDetails = [...contactsList];
        updatedContatcDetails[contactRes.index].phone = '91';
        updatedContatcDetails[contactRes.index].name = '';
        updatedContatcDetails[contactRes.index].email = '';
        updatedContatcDetails[contactRes.index].designation = '';
        setContactList(updatedContatcDetails);
        setShowAddContactDetails('')
        setShowAddContactModal(false)
    }

    const onCloseConfirma = () => {
        setSelectedAssignedTo({userId:selectedFunnel?.assignedUser?.id, name:selectedFunnel?.assignedUser?.name});
        showConfirmationDialog('')
    }

    const onConfirmSwitch = () =>{
        selectedAssignedTo.name = confirmationModal.name,
        selectedAssignedTo.userId = confirmationModal.id,
        setSelectedAssignedTo({ ...selectedAssignedTo })
        showConfirmationDialog('')

    }




    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const updatedStates1 = [...dropdownOpenStates1];

            selectRefs1.current.forEach((ref: any, index: any) => {
                if (ref.current && !ref.current.contains(event.target as Node)) {
                    updatedStates1[index] = false; // Close dropdown if clicked outside
                }
            });

            setDropdownOpenStates1(updatedStates1);

            const updatedStates = [...dropdownOpenStates];

            selectRefs.current.forEach((ref: any, index: any) => {
                if (ref.current && !ref.current.contains(event.target as Node)) {
                    updatedStates[index] = false; // Close dropdown if clicked outside
                }
            });

            setDropdownOpenStates(updatedStates);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownOpenStates1, dropdownOpenStates]);

    const handleMenuOpen1 = (index: any) => {
        const updatedStates = [...dropdownOpenStates1];
        updatedStates[index] = true;
        setDropdownOpenStates1(updatedStates);
    };

    const handleMenuClose = (index: any) => {
        const updatedStates = [...dropdownOpenStates];
        updatedStates[index] = false;
        setDropdownOpenStates(updatedStates);
    };

    const handleMenuOpen = (index: any) => {
        const updatedStates = [...dropdownOpenStates];
        updatedStates[index] = true;
        setDropdownOpenStates(updatedStates);
    };

    const handleMenuClose1 = (index: any) => {
        const updatedStates = [...dropdownOpenStates1];
        updatedStates[index] = false;
        setDropdownOpenStates1(updatedStates);
    };




    const CustomValueContainer1 = (props: any) => {
        const { selectProps } = props;
        const index = selectProps.index;
        return <ValueContainer1 {...props} setDropdownOpen={() => handleMenuOpen1(index)} />;
    };
    CustomValueContainer1.displayName = "CustomValueContainer1";

    const CustomValueContainer = (props: any) => {
        const { selectProps } = props;
        const index = selectProps.index;
        return <ValueContainer {...props} setDropdownOpen={() => handleMenuOpen(index)} />;
    };
    CustomValueContainer.displayName = "CustomValueContainer";



    const onFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFiles = event.target.files as FileList;
        setUploadedAudio('');
        UploadInstitutePic(selectedFiles?.[0]);
    };

    const UploadInstitutePic = async (selectedFiles: any) => {
        if (selectedFiles && (selectedFiles.type === 'audio/mpeg' || selectedFiles.type === 'audio/mp3' || selectedFiles.type === 'audio/wav') && selectedFunnel) {
            const funneldId = selectedFunnel && selectedFunnel?.id ? selectedFunnel.id : '0'
            const formData = new FormData();
            formData.append('file', selectedFiles);
            formData.append('funnelId', funneldId);
            formData.append('type', 'audioFile');

            const response = await uploadPicture.mutateAsync({
                file: formData,
            });
            // console.log("respppp", response)
            setUploadedAudio(response ? response.audioUrl : '');
        } else {
            showNotification({
                type: 'error',
                title: 'Incorrect file, please upload a valid audio file (mp3, wav, etc.).',
            });
        }
    };
    const onUploadImageHandler = () => {
        if (fileInputRef && fileInputRef.current) {
            (fileInputRef.current as any).click();
        }
    };

    const getUsersList = async (pageIndex: number, reset = false, filter?: any) => {
        const res = await useGetUsersMutation.mutateAsync({
            page: pageIndex,
            perPage: 500,
            search: '',
            filter: { 'rolesId': [2, 3, 4] },
        });
        if(res){
            const filteredUserList = res?.list.filter((u: any) =>
                u.location.some((loc: any) => 
                  Number(loc.state.id) === Number(selectedFunnel?.institute?.state?.id) && Number(loc.city.id) === Number(selectedFunnel?.institute?.city?.id)
                )
              );
            
              const filteredUsers = filteredUserList.filter((user: any) =>
                [2, 3, 4].includes(Number(user.userRoleId))
              );
            
              setUsersList(filteredUsers); 
        }

    };


    const handleStartRecording = async () => {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                const recorder = new MediaRecorder(stream);

                recorder.ondataavailable = (event: any) => {
                    if (event.data.size > 0) {
                        chunks.current.push(event.data);
                    }
                };

                recorder.onstop = () => {
                    const blob = new Blob(chunks.current, { type: "audio/webm" });
                    const url = URL.createObjectURL(blob);
                    setAudioUrl(url);
                    chunks.current = [];
                };

                recorder.start();
                // UploadInstitutePic(recorder);
                setMediaRecorder(recorder);
                setIsRecording(true);
            } catch (error) {
                console.error("Error accessing audio devices:", error);
            }
        } else {
            console.error("getUserMedia is not supported in this browser.");
        }
    };

    const handleStopRecording = async () => {
        if (mediaRecorderAudio) {
            mediaRecorderAudio.stop();
            setIsRecording(false);

            mediaRecorderAudio.onstop = async () => {
                const blob = new Blob(chunks.current, { type: "audio/webm" });
                const url = URL.createObjectURL(blob);
                setAudioUrl(url);
                chunks.current = [];

                const audioFile = new File([blob], "recording.webm", { type: "audio/webm" });

                const funneldId = selectedFunnel && selectedFunnel?.id ? selectedFunnel.id : '0';
                const formData = new FormData();
                formData.append('file', audioFile);
                formData.append('funnelId', funneldId);
                formData.append('type', 'audioFile');

                try {
                    const response = await uploadPicture.mutateAsync({
                        file: formData,
                    });
                    setUploadedAudio(response ? response.audioUrl : '');
                } catch (error) {
                    console.error("Error uploading audio:", error);
                    showNotification({
                        type: 'error',
                        title: 'Failed to upload the audio file.',
                    });
                }
            };
        }
    };

    const calculateCumulativePrice = (products: any[]) => {
        const total = products.reduce((acc, product) => {
            const price = Number(product.price || 0);
            const quantity = Number(product.quantity || 1); 
            return acc + (price * quantity);
        }, 0);
        setDealSize(total);
      };

      useEffect(() => {
        calculateCumulativePrice(productDetails);
      }, [productDetails]);

    const formatDate = (date: Date) => ({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      });

      const formatAfterDate = (date: Date) => ({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()+ 1,
      });
      
      const today = formatDate(new Date());
      const last10days = formatDate(
        new Date(new Date().setDate(new Date().getDate() - 9))
      );
      const Aftertoday = formatAfterDate(new Date());

    const formatDateRange = () => {
        if (selectedDate) {
            return moment({
              year: selectedDate?.year,
              month: selectedDate?.month ? selectedDate?.month - 1 : 0,
              day: selectedDate?.day,
            }).format('DD MMM YYYY');
          } else { 
            return 'Select Date';
            
            // const afterToday = moment().add(1, 'day');
            // return afterToday.format('DD MMM YYYY');
          }
    };

    const formatDateRange1 = () => {
        return lastCoverageDate
            ? moment({
                year: lastCoverageDate?.year,
                month: lastCoverageDate?.month ? lastCoverageDate?.month - 1 : 0,
                day: lastCoverageDate?.day,
            }).format('DD MMM YYYY')
            : 'Select Date';
    };

    const getPhoneNumberDetails = async (data: any, index: any) => {
        if (data) {
            const response = await useGetPhoneDetailsMutation.mutateAsync({
                phone: data,
                instituteName: selectedFunnel?.institute?.name,
                stateId: selectedFunnel?.institute?.state?.id,
                cityId: selectedFunnel?.institute?.city?.id
            });
            if (response) {
                setShowAddContactModal(true);
                setShowAddContactDetails({ ...response, index: index })

            }
        }
    }

   
      

    return (
        <div className='edit-funnel-container'>
            <div className='funnel-institute-details'>
                <div className='institute-name-details'>
                    <div className='institute-name'>
                        {selectedFunnelDetails?.institute?.name}
                    </div>
                    <div className='assigned-user mb-2'> {selectedFunnelDetails?.institute?.state?.name},  {selectedFunnelDetails?.institute?.city?.name}</div>
                    <div className='assigned-user'> {selectedFunnelDetails?.assignedUser?.name}
                        {"  "} <div className="horizontal-line"></div><div className={`funnels-bg ${FUNNEL_TYPES.BOOK_FUNNEL === selectedFunnelDetails?.type ? "change-bg" : ''}`}> {FUNNEL_TYPES.BOOK_FUNNEL !== selectedFunnelDetails?.type ? <BookFunnelIcon className='book-funnel-icon' /> : <ProductFunnelicon className='book-funnel-icon' />}{FUNNEL_TYPES.BOOK_FUNNEL === selectedFunnelDetails?.type ? 'Books Funnel' : 'Platform Funnel'}</div>
                    </div>
                    {/* <div className='details-panel'>
                    <Locationicon />
                    <div className='ddd-details'>
                        <div className='tags'>State and city</div>
                        <div className='s-c-detail'>
                            {selectedFunnelDetails?.institute?.state?.name},  {selectedFunnelDetails?.institute?.city?.name}
                        </div>
                    </div>
                </div> */}
                </div>
                <div className='update-funnel-btn'>
                    <div className='update-btn'>
                        <button
                            className={`steam-button cancel-button `}
                            onClick={() => { onEditClick() }}
                        >
                            <span>Cancel</span>
                        </button>
                    </div>
                    <div className='archive-btn'>
                        <button
                            className={`steam-button button-dark display-flex`}
                            onClick={() => { updateFunnelDetails() }}
                        >
                            <span>Update</span>
                        </button>
                    </div>
                </div>

            </div>


            <div className='divider mt-4'></div>
<div className='add-scroller'>
            <div className='edit-funnel-product-details'>
                <div className='pd-title mb-2'>
                    <div className='title'><ProductIcon />Product Details  {selectedFunnel && selectedFunnel?.productGroups && selectedFunnel?.productGroups.length === 0 && <div>- Catapult</div>}</div>
                    <div className='size'>
                        {FUNNEL_TYPES.BOOK_FUNNEL === selectedFunnelDetails?.type ? <button className='steam-button invert-button' onClick={() => { addNewProduct() }}>+ Add New</button> : <div className='deal-size-edit mt-2'>
                            <div className='title change'>
                                Deal size
                            </div>
                            <div className='input-data'>
                                <input
                                    className={`custome-input width-150`}
                                    placeholder={'Deal size'}
                                    onChange={(e) => {
                                        setDealSize(e.target.value);
                                    }}
                                    value={delaSize}
                                    id="dealSize"
                                />
                            </div>

                        </div>}
                    </div>
                </div>

                {selectedFunnel && selectedFunnel?.productGroups && selectedFunnel?.productGroups.length > 0 &&
                    <table className='product-details-tab'>
                        <thead>
                            <tr className='product-header'>
                                <th className='name'>Target Products</th>
                                <th className='qty'>Qty</th>
                                <th className='sub'>Subject</th>
                                <th className='class'>Class</th>
                                <th className='price'>Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {productDetails && productDetails.length > 0 && productDetails.map((item: any, index: any) => {
                                return (
                                    <tr className='product-values' key={index}>
                                        <td className='name'>
                                            <Dropdown className="new-figma-drop-down">
                                                <Dropdown.Toggle
                                                    variant="success"
                                                    className="drop-down-btn funnel-drp--width dropdown-toggle"
                                                    id="dropdown-basic"
                                                    disabled={item?.id ? true : false}
                                                >
                                                    {item?.product ? item?.product?.name : 'Select product'}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu className="Duration-drop-down">
                                                    {productList?.map((itemProd: any, prodIndex: any) => (
                                                        <Dropdown.Item
                                                            key={prodIndex}
                                                            onClick={() => {
                                                                const updatedProductDetails = [...productDetails];
                                                                updatedProductDetails[index].productId = itemProd.id;
                                                                updatedProductDetails[index].product = itemProd;
                                                                updatedProductDetails[index].subject = [];
                                                                updatedProductDetails[index].class = [];
                                                                setProductDetails(updatedProductDetails);
                                                            }}
                                                            eventKey={itemProd.name}
                                                            disabled={item?.id ? true : false}
                                                        >
                                                            <div className="menu-item-minutes">{itemProd.name}</div>
                                                        </Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </td>
                                        <td className='qty'>
                                            <input
                                                className={`custome-input width-unset`}
                                                placeholder={'Qty'}
                                                onChange={(e) => {
                                                    const updatedProductDetails = [...productDetails];
                                                    updatedProductDetails[index].quantity = e.target.value;
                                                    setProductDetails(updatedProductDetails);
                                                }}
                                                value={item.quantity}
                                                id="quantity"
                                            />
                                        </td>
                                        <td >
                                            <div className='sub'>
                                                {/* <div className="table-contact  font-valeu"> */}
                                                <div className="user-first-last-div petsked-form" ref={selectRefs.current[index]}>
                                                    <ReactSelect
                                                        className="multiselect-react funnel-product-height"
                                                        options={
                                                            productList && item.productId
                                                                ? productList
                                                                    .find((product: any) => product.id === item.productId)?.subject
                                                                    ?.map((subject: any) => ({
                                                                        value: subject.id,
                                                                        label: subject.name,
                                                                        name: subject.name,
                                                                        id: subject.id
                                                                    })).sort((a: any, b: any) => a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: 'base' })) ?? []
                                                                : []
                                                        }
                                                        isMulti={true}
                                                        closeMenuOnSelect={false}
                                                        hideSelectedOptions={false}
                                                        classNamePrefix={'petsked-multiselect'}
                                                        onChange={(selected: any) => {
                                                            const updatedProductDetails = [...productDetails];
                                                            updatedProductDetails[index].subject = selected.map((subject: any) => subject.value);
                                                            setProductDetails(updatedProductDetails);
                                                        }}
                                                        getOptionLabel={(option: any) => option.name}
                                                        getOptionValue={(option: any) => option.id}
                                                        components={{
                                                            Option,
                                                            ValueContainer: CustomValueContainer,
                                                        }}
                                                        placeholder={'Subject'}
                                                        onMenuOpen={() => handleMenuOpen(index)}
                                                        onMenuClose={() => handleMenuClose(index)}
                                                        menuIsOpen={dropdownOpenStates[index]}
                                                        value={
                                                            item.subject && item.productId
                                                                ? item.subject
                                                                    .map((subjectId: string) => {
                                                                        const selectedProduct = productList.find(
                                                                            (product: any) => product.id === item.productId
                                                                        );

                                                                        const foundSubject = selectedProduct?.subject?.find(
                                                                            (subj: any) => subj.id === subjectId
                                                                        );

                                                                        return foundSubject
                                                                            ? {
                                                                                value: foundSubject.id,
                                                                                label: foundSubject.name,
                                                                                name: foundSubject.name,
                                                                                id: foundSubject.id
                                                                            }
                                                                            : null;
                                                                    })
                                                                    .filter((subject: any) => subject !== null)
                                                                : []
                                                        }
                                                    //  isDisabled={locationDetails.state.trim() === ''}

                                                    />
                                                </div>
                                                {/* </div> */}
                                            </div>
                                        </td>
                                        <td >
                                            <div className='class'>
                                                <div onClick={() => console.log("Wrapper clicked")} className="user-first-last-div petsked-form" ref={selectRefs1.current[index]}>
                                                    <ReactSelect
                                                        className="multiselect-react funnel-product-height"
                                                        options={
                                                            productList && item.productId
                                                                ? productList
                                                                    .find((product: any) => product.id === item.productId)?.subject
                                                                    ?.filter((subject: any) => item?.subject && item.subject.length > 0 && item.subject.includes(subject.id))
                                                                    .flatMap((subject: any) => subject.classes)
                                                                    .map((classItem: any) => ({
                                                                        value: classItem.id,
                                                                        label: classItem.name,
                                                                        name: classItem.name,
                                                                        id: classItem.id
                                                                    })).sort((a: any, b: any) => a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: 'base' })) ?? []
                                                                : []
                                                        }
                                                        blurInputOnSelect={true}
                                                        isMulti={true}
                                                        closeMenuOnSelect={false}
                                                        hideSelectedOptions={false}
                                                        classNamePrefix={'petsked-multiselect'}
                                                        onChange={(selected: any) => {
                                                            const updatedProductDetails = [...productDetails];
                                                            updatedProductDetails[index].class = selected.map((cls: any) => cls.value);
                                                            setProductDetails(updatedProductDetails);
                                                        }}
                                                        getOptionLabel={(option: any) => option?.name}
                                                        getOptionValue={(option: any) => option?.id}
                                                        components={{
                                                            Option: Option1,
                                                            ValueContainer: CustomValueContainer1,
                                                        }}
                                                        placeholder={'class'}
                                                        // onMenuOpen={() => setDropdownOpen1(true)} 
                                                        // onMenuClose={() => setDropdownOpen1(false)} 
                                                        // menuIsOpen={dropdownOpen1}

                                                        onMenuOpen={() => handleMenuOpen1(index)}
                                                        onMenuClose={() => handleMenuClose1(index)}
                                                        menuIsOpen={dropdownOpenStates1[index]}
                                                        value={
                                                            item.class && item.productId
                                                                ? item.class
                                                                    .map((classId: string) => {
                                                                        const selectedProduct = productList.find(
                                                                            (product: any) => product.id === item.productId
                                                                        );

                                                                        const foundClass = selectedProduct?.subject
                                                                            ?.flatMap((subj: any) => subj.classes)
                                                                            ?.find((cls: any) => cls.id === classId);

                                                                        return foundClass
                                                                            ? {
                                                                                value: foundClass.id,
                                                                                label: foundClass.name,
                                                                                name: foundClass.name,
                                                                                id: foundClass.id
                                                                            }
                                                                            : null;
                                                                    })
                                                                    .filter((cls: any) => cls !== null)
                                                                : []
                                                        }
                                                        onBlur={() => {
                                                            // Trigger when clicking outside
                                                            console.log("Dropdown blurred");
                                                        }}

                                                    />
                                                </div>
                                            </div>
                                        </td>
                                        <td className='price'>
                                            <input
                                                className={`custome-input width-unset`}
                                                placeholder={'Price'}
                                                onChange={(e) => {
                                                    const updatedProductDetails = [...productDetails];
                                                    updatedProductDetails[index].price = e.target.value;
                                                    setProductDetails(updatedProductDetails);
                                                }}
                                                value={item.price}
                                                id="price"
                                            />
                                        </td>
                                        <td className='delete'>
                                            {index !== 0 && <Deleteicon onClick={() => {
                                                const updatedProductDetails = productDetails.filter((_, i) => i !== index);
                                                setProductDetails(updatedProductDetails);
                                            }} />}
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                }


            </div>

            {/* <div className='divider mt-4'></div> */}

            {FUNNEL_TYPES.BOOK_FUNNEL === selectedFunnelDetails?.type && <div className='deal-size-edit mt-2'>
                <div className='title'>
                    Deal size
                </div>
                <div className='input-data'>
                    <input
                        className={`custome-input width-150`}
                        placeholder={'Deal size'}
                        onChange={(e) => {
                            setDealSize(e.target.value);
                        }}
                        value={delaSize}
                        id="dealSize"
                    />
                </div>

            </div>}


            <div className='divider mt-4'></div>

            <div className='edit-funnel-details'>
                <div className='funnel-title'>
                    <FunnelIcon /> Funnel Details

                </div>
                <div className='funnel-desc'>
                </div>
            </div>

            <div className='edit-funnel-followup mt-4'>
                {/* <div className='details-panel'>
                    <Locationicon />
                    <div className='ddd-details'>
                        <div className='tags'>State and city</div>
                        <div className='s-c-detail'>
                            {selectedFunnelDetails?.institute?.state?.name},  {selectedFunnelDetails?.institute?.city?.name}
                        </div>
                    </div>
                </div> */}

                <div className='details-panel'>

                    <Calendericon />
                    <div className='ddd-details'>
                        <div className='tags'>Date of Visit/Call</div>
                        <div className='s-c-detail'>
                            <div className="date-filter-maps">
                            <DatePicker
                                formatInputText={formatDateRange1}
                                value={lastCoverageDate}
                                onChange={(newDate: any) => {
                                    if (newDate) {
                                        setLastCoverageDate(newDate);
                                    }
                                }}
                                inputPlaceholder="Select a day"
                                inputClassName='steam-rangepicker'
                                colorPrimary="#002083"
                                colorPrimaryLight="#002083"
                                maximumDate={today}
                                minimumDate={last10days}
                            />
                            </div>

                        </div>
                    </div>
                </div>

                <div className='details-panel'>
                    <Statusicon />
                    <div className='ddd-details'>
                        <div className='tags'>Funnel Stage</div>
                        <div className='s-c-detail'>

                            <div className="user-first-last-div iscity-drp petsked-form">
                                <Dropdown className="new-figma-drop-down">
                                    <Dropdown.Toggle
                                        variant="success"
                                        className="drop-down-btn funnel-width-half dropdown-toggle"
                                        id="dropdown-basic"
                                    >
                                        {setSelectedFunnelStage ? setSelectedFunnelStage : 'Select stage'}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="Duration-drop-down">
                                        {funnelStages?.map((item: any, index: any) => {
                                            return (
                                                <Dropdown.Item
                                                    key={index}
                                                    onClick={() => {
                                                        if (selectedFunnelDetails) {
                                                            setSelectedFunnelState(item.name)
                                                            selectedFunnelDetails.stageId = item.id
                                                            setselectedFunnelDetails({ ...selectedFunnelDetails })
                                                        }
                                                    }}
                                                    eventKey={item.name}
                                                >
                                                    <div className="menu-item-minutes">{item.name}</div>
                                                </Dropdown.Item>
                                            );
                                        })}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                </div>

                {Number(user?.userRoleId) === 1 && <div className='details-panel'>
                    <Statusicon />
                    <div className='ddd-details'>
                        <div className='tags'>Assign To</div>
                        <div className='s-c-detail'>
                            {console.log("selectedAssignedTo", selectedAssignedTo)}

                            <div className="user-first-last-div iscity-drp petsked-form">
                                <Dropdown className="new-figma-drop-down">
                                    <Dropdown.Toggle
                                        variant="success"
                                        className="drop-down-btn funnel-width-half dropdown-toggle"
                                        id="dropdown-basic"
                                    >
                                        {selectedAssignedTo?.name ? selectedAssignedTo?.name : 'Select user'}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="Duration-drop-down">
                                        {usersList?.map((item: any, index: any) => {
                                            return (
                                                <Dropdown.Item
                                                    key={index}
                                                    onClick={() => {

                                                        if(Number(item?.id) !== Number(selectedFunnel?.assignedUser?.id)){
                                                            showConfirmationDialog(item)
                                                        }
                                                        
                                                      //  setSelectedState({ state: '', stateId: null });
                                                        //setSelectedCity({ city: '', cityId: null });
                                                        //filterStatesBasesOnassignedUser(item.id);
                                                        // selectedAssignedTo.name = item.name,
                                                        //     selectedAssignedTo.userId = item.id,
                                                        //     setSelectedAssignedTo({ ...selectedAssignedTo })
                                                    }}
                                                    eventKey={item.name}
                                                >
                                                    <div className="menu-item-minutes">{item.name}</div>
                                                </Dropdown.Item>
                                            );
                                        })}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                </div>}

            </div>

            <div className='divider mt-4'></div>



            <div className='funnel-edit-coverage-details mt-4'>
                <div className='cd-title mb-2'>
                    <div className='coverage-title'><Coverageicon />Coverage Details</div>
                    <div className='coverage-type'>
                        {/* <Callicon />In Person */}
                        <div className='tab-selection-conatct'>
                            <div className={`tab-selection  ${selectedContactType === 1? 'selected' : ''}`} onClick={() => { setSelectedContactType(1) }}>
                                In Person
                            </div>
                            <div className={`tab-selection ${selectedContactType===2 ? 'selected' : ''}`} onClick={() => { setSelectedContactType(2) }}>
                                Telephonic
                            </div>

                        </div>
                    </div>
                </div>

                <div className='lst-title mt-4'>
                    <div className='title'>
                    Who did you meet/talk to?
                    </div>
                    <div className='size'>
                        <button className='steam-button invert-button' onClick={() => { addNewcontact() }}>+ Add New</button>
                    </div>
                </div>
                <div className='contacts-div'>
                    {contactsList && contactsList.length > 0 && contactsList.map((item: any, index: any) => {
                        return (
                            <div>
                                {item?.id ? <div key={index} className={`lst-details ${item?.isKeyPerson ? 'is-primary' : ''}`}>

                                    <div className='user-left'>
                                        <div>
                                            <label htmlFor={`option-check-${index}`} className="check-container">
                                                <input
                                                    checked={item?.isKeyPerson}
                                                    id={`option-check-${index}`}
                                                    type="checkbox"
                                                    onChange={() => {
                                                        const updatedContacts = contactsList.map((contact: any, i: number) =>
                                                            i === index ? { ...contact, isKeyPerson: !contact.isKeyPerson } : contact
                                                        );
                                                        // const updatedContacts = contactsList.map((contact: any, i: number) => ({
                                                        //     ...contact,
                                                        //     isKeyPerson: i === index ? true : false,
                                                        // }));
                                                        setContactList(updatedContacts);
                                                    }}
                                                />
                                                <span className="checkmark"></span>
                                            </label>
                                        </div>
                                        <InitialsAvatar name={item?.name ? item.name.charAt(0).toUpperCase() : 'SA'} className="avatar padding-coverage" />
                                        {item.name} {"  "} <div className="horizontal-line-1"></div><div className={`user-email`}> {item.email}</div>{item?.designation && <><div className="horizontal-line-1"></div><div className={`user-email`}> {item.designation}</div></>}
                                    </div>
                                    <div className='user-right'>
                                        <div className={`user-phone`}> {Utils.getPhone(item.phone)}</div>
                                         {/* {index !== 0 && <Deleteicon onClick={() => {
                                            const updatedContatcDetails = contactsList.filter((_, i) => i !== index);
                                            setContactList(updatedContatcDetails);
                                        }} />} */}
                                    </div>

                                </div> : <div className='add-new-contact-funnel' key={index}>

                                    <label htmlFor={`option-check-${index}`} className="check-container">
                                        <input
                                            checked={item?.isKeyPerson}
                                            id={`option-check-${index}`}
                                            type="checkbox"
                                            onChange={() => {
                                                const updatedContacts = contactsList.map((contact: any, i: number) => ({
                                                    ...contact,
                                                    isKeyPerson: i === index ? true : false,
                                                }));
                                                setContactList(updatedContacts);
                                            }}
                                        />
                                        <span className="checkmark"></span>
                                    </label>

                                    <input
                                        className={`custome-input funnel-width-unset`}
                                        placeholder={'Name'}
                                        onChange={(e) => {
                                            const updatedContatcDetails = [...contactsList];
                                            updatedContatcDetails[index].name = e.target.value;
                                            setContactList(updatedContatcDetails);
                                        }}
                                        value={item.name}
                                        id="name"
                                    />
                                    <input
                                        className={`custome-input funnel-width-unset`}
                                        placeholder={'Email'}
                                        onChange={(e) => {
                                            const updatedContatcDetails = [...contactsList];
                                            updatedContatcDetails[index].email = e.target.value;
                                            setContactList(updatedContatcDetails);
                                        }}
                                        value={item.email}
                                        id="email"
                                    />
                                    <div className="user-first-last-div iscity-drp petsked-form">
                                        <Dropdown className="new-figma-drop-down">
                                            <Dropdown.Toggle
                                                variant="success"
                                                className="drop-down-btn designation-drp--width dropdown-togge"
                                                id="dropdown-basic"
                                            >
                                                {item?.designation ? item?.designation : 'Designation'}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className="Duration-drop-down">
                                                {DESIGNATION_TYPES.map((itemProd: any, prodIndex: any) => {
                                                    return (
                                                        <Dropdown.Item
                                                            key={prodIndex}
                                                            onClick={() => {
                                                                const updatedContatcDetails = [...contactsList];
                                                                updatedContatcDetails[index].designation = itemProd;
                                                                setContactList(updatedContatcDetails);
                                                            }}
                                                            eventKey={itemProd}
                                                        >
                                                            <div className="menu-item-minutes">{itemProd}</div>
                                                        </Dropdown.Item>
                                                    );
                                                })}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                    <div className="new-figma-phone funnel-phone">
                                        <PhoneInput
                                            placeholder="phone no"
                                            value={item.phone}
                                            onChange={(value) => {
                                                const updatedContacts = [...contactsList];
                                                updatedContacts[index].phone = value;
                                                setContactList(updatedContacts);
                                                getPhoneNumberDetails(value, index);
                                            }}
                                            //   className={`custome-input funnel-width-unset`}
                                            country={'in'}
                                            countryCodeEditable={false}
                                        />
                                    </div>
                                   {index !== 0 && <Deleteicon onClick={() => {
                                        const updatedContatcDetails = contactsList.filter((_, i) => i !== index);
                                        setContactList(updatedContatcDetails);
                                    }} />}
                                </div>}
                            </div>
                        )
                    })}



                </div>

                <div className='lst-title mt-4'>
                    Coverage Details
                </div>

                <div className='coverage-details-text mt-2'>
                    {/* {selectedFunnel?.comments} */}

                    <div className='user-first-last-div'>
                        <textarea
                            className="new-cust-input message-input-funnel"
                            placeholder="Coverage details.."
                            onChange={(ev) => setComments(ev.target.value)}
                            value={comments}
                        />
                    </div>
                    {isRecording && (
                        <div className="recording-overlay">
                            <div className="recording-overlay-content">
                                <p> <img src={RedDataRecordingIcon} /> Recording in progress...</p>
                                <button className='steam-button button-no-bg-stroke' onClick={handleStopRecording}>Stop Recording</button>
                            </div>
                        </div>
                    )}
                    {!uploadedAudio && <div className='upload-audio'>
                        <button className='audion-btn' onClick={isRecording ? handleStopRecording : handleStartRecording}>
                            {isRecording ? <RecordingIcon /> : <RecordingIcon />}
                        </button>
                        <UploadAudioIcon onClick={onUploadImageHandler} />
                        <div className="form-group">
                            <input
                                type="file"
                                accept="audio/*"
                                onChange={onFileSelect}
                                ref={fileInputRef}
                                hidden
                            />
                        </div>
                    </div>}

                    {uploadPicture?.isLoading && <div className='mt-5'> <Loader text='Uploading audio...' /> </div>}
                    {uploadedAudio && <div className='mt-3'>
                        <AudioPlayer audioUrl={uploadedAudio} removeFile={() => { setUploadedAudio('') }} />
                    </div>}

                </div>
                <div className='lastcoverage-div mt-5'>
                    <div className='lastcoverage-title'>
                        <LastCoverageIcon /> Next Followup date

                    </div>
                    <div className='last-coverage-date'>
                        <div className="date-filter-maps">
                            

<DatePicker
                                    formatInputText={formatDateRange}
                                    value={selectedDate}
                                    onChange={(newDate: any) => {
                                        if (newDate) {
                                            setSelectedDate(newDate);
                                        }
                                    }}
                                    inputPlaceholder="Select a day"
                                    inputClassName='steam-rangepicker'
                                    colorPrimary="#002083"
                                    colorPrimaryLight="#002083"
                                    minimumDate={Aftertoday}
                                />
                        </div>
                    </div >

                </div>

                <div className='divider mt-4'></div>
                <div className='lorem-text'>
                </div>


            </div>

            </div>
            <DeleteConfirmation  open={confirmationModal?.id ? true : false} onClose={onCloseConfirma} onConfirm={onConfirmSwitch} message={`Do you want to re-assign this funnel to this user - ${confirmationModal?.name} ?`} subText='Assign To' />
            <DeleteConfirmation data={contactRes} open={showAddContactModal} onClose={onClose} onConfirm={onConfirm} message='This phone no is already assigned to a user of another institute do you want to switch that user to this new institute ?' subText='Switch user' />
        </div>
    );
};


const Option1 = (props: any) => {
    const {
        data: { avatarUrl, name, email },
        isSelected,
        selectOption,
    } = props;

    const handleOptionClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        selectOption(props.data);
    };

    return (
        <div key={`options-sp${props.value}`} onClick={handleOptionClick} >
            <components.Option {...props} onClick={handleOptionClick} >
                <div
                    className="service-provider-option funnelsubject-width"

                >
                    <div className="left-details">
                        <span>
                            <label className="name">{name}</label>
                        </span>
                    </div>
                    <div>
                        <label htmlFor={`option-check-${props.value}`} className="check-container">
                            <input
                                checked={isSelected}
                                id={`option-check-${props.value}`}
                                type="checkbox"
                            //readOnly
                            />
                            <span className="checkmark"></span>
                        </label>
                    </div>
                </div>
            </components.Option>
        </div>
    );
};




const Option = (props: any) => {
    const {
        data: { avatarUrl, name, email },
        isSelected,
        selectOption,
    } = props;


    const handleOptionClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        selectOption(props.data);
    };

    return (
        <div key={`options-sp${props.value}`} onClick={handleOptionClick}>
            <components.Option {...props} onClick={handleOptionClick}>
                <div className="service-provider-option funnelsubject-width" >
                    <div className="left-details">
                        {/* <img className="rounded-full border-0" src={avatarUrl} referrerPolicy="no-referrer" /> */}
                        <span>
                            <label className="name">{name}</label>
                            {/* <label className="email">{email}</label> */}
                        </span>
                    </div>
                    <div>
                        <label htmlFor={`option-check-${props.value}`} className="check-container">
                            <input
                                checked={isSelected}
                                id={`option-check-${props.value}`}
                                type="checkbox"
                            // readOnly
                            />
                            <span className="checkmark"></span>
                        </label>
                    </div>
                </div>
            </components.Option>
        </div>
    );
};
const ValueContainer = (props: any) => {
    const { setDropdownOpen } = props;
    const valueLength = props.getValue().length;
    return (
        <components.ValueContainer {...props} onClick={() => setDropdownOpen(true)}>
            {valueLength === 0 && <span className="react-select-custom-placeholder funnel-filter-height ">subject</span>}
            {props.getValue().length > 0 &&
                !props.selectProps.inputValue &&
                `+${valueLength}`}
            {/* {React.Children.map(props.children, (child) => {
                return child.type === components.Input ? child : null;
            })} */}
        </components.ValueContainer>
    );
};



const ValueContainer1 = (props: any) => {
    const { setDropdownOpen } = props;
    const valueLength = props.getValue().length;

    return (
        <components.ValueContainer {...props} onClick={() => setDropdownOpen()}>
            {valueLength === 0 && <span className="react-select-custom-placeholder funnel-filter-height">class</span>}
            {valueLength > 0 && !props.selectProps.inputValue && `+${valueLength}`}
        </components.ValueContainer>
    );
};


export default EditFunnel;
